import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBranch } from 'app/shared/Domains/branch';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Configuration } from 'config/config';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-contactus",
    templateUrl: "./contactus.component.html",
    styleUrls: ["./contactus.component.css"]
})
export class ContactUsComponent implements OnInit {
    contactUsdata: any;
    messageService: any;
    branches: IBranch;
    active: boolean = true;
    previewUrl: string;
    selectedFile: File;
    member: any;
    isEmailLoader: boolean = false;
    loading: boolean = false;
    isSuccess: boolean;
    isError: boolean;
    tableData: any[] = [];
    selectedBranch: any;
    branch: string;
    company: string;
    balance: number;
    contactUs: any[] = [];
    ContactUsdata: any = [];
    totalCounter: any;
    displayMessageDialog: boolean = false;
    selectedMessage: string = '';

    openMessageDialog(message: string) {
        this.selectedMessage = message;
        this.displayMessageDialog = true;
    }


    constructor(private LanguageService: LanguageService, private route: ActivatedRoute,
        public config: Configuration,
        private appServiceManager: AppServiceManager,


    ) { }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("ContactUsComponent", label);
      }
    ngOnInit(): void {
        this.getContactUs();
    }


    getContactUs() {
        let endpoint = `contactUs/`;
        this.appServiceManager.get(endpoint).subscribe(
            (res: any) => {
                if (res) {
                    this.contactUsdata = res.data;
                    this.totalCounter = this.contactUsdata.length;
                    let counter = 0;
                    console.log(this.contactUsdata);
                    this.contactUsdata = this.contactUsdata.map(item => ({
                        createdDate: new Date(item?.createdDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
                        name: item?.name,
                        phone: item?.phone,
                        email: item?.email,
                        subject: item?.subject,
                        message: item?.message,
                        source: item?.source,
                        counter: counter = counter + 1
                    }));
                } else {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                }
            },
            (error: any) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            }
        );
    }


}